import { SET_SELECTED_PAYER_ID } from "../../actions/action.types";

const selectedPayerId = (state = "", action: any) => {
  if (action.type === SET_SELECTED_PAYER_ID) return action.payload;
  return state;
};

export default selectedPayerId;
